import axios from 'axios';
import router from '@/router'

const port = (window.location.protocol.includes('https'))? "443": `${process.env.VUE_APP_BACKEND_PORT}`;
const state = () => ({
  myAxios: axios.create({
    // baseURL: `https://aceros.koiote.es:443/api`,
    baseURL: `${window.location.protocol}//${window.location.hostname}:${port}/api`,
    headers: {
      "Content-Type": "application/json",
      common: {
        "Authorization": 'Bearer ' + localStorage.getItem('token') || null
      }
    },
  }),
  user: {},
})
const getters = {
  getUser(){
    return JSON.parse(localStorage.getItem('user'))
  },
  getToken(){
    return localStorage.getItem('token')
  },
  getAxios(state){
    return state.myAxios
  },
}
const mutations = {
}
const actions = {

  //  AXIOS INTERCEPTORS SETUP
  setUpInterceptors({state}){
    state.myAxios.interceptors.request.use(function(config) {
      let token = localStorage.getItem('token')
      if(token) {
        config.headers.Authorization = `Bearer ${token}`;
      }else{
      }
      return config;
    }, function(err) {
        return Promise.reject(err);
    });
    state.myAxios.interceptors.response.use((response) => {
        // If the response status is between 200 and 299, it's a successful response, so return it as is.
        return response;
      },(error) => {
        if (error.response && error.response.status === 413) {
         //console.error('Payload Too Large (413) - The server refused to process the request due to large payload.');
        }else if(error.response && error.response.status === 401){
          this.dispatch('api/logout')
        }else if(error.response && error.response.status === 400){
          console.warn("HA HABIDO UN ERROR EN AXIOS: ",error.response.data.msg?error.response.data.msg:error.response);
          // console.log(error.response.data.msg?error.response.data.msg:error.response)
        }
        // return Promise.reject(error);
      }
    );
  },
  setRol(state, value){
    console.log('Entro en setROl');
    switch (value) {
      case 1:
        state.rol = 'admin'
        break;
      case 2:
        state.rol = 'avanzado'
        break;
      case 3:
        state.rol = 'normal'
        break;
      default:
        state.rol = 'normal'
        break;
    }
  },
    //  LOGIN & LOGOUT
  async login({ state }, userInfo) {
    try {

      const res = await state.myAxios.post('auth/login/', userInfo)
      console.log("res",res)

      this.dispatch('api/setToken', res.data.token)
      this.dispatch('api/setUser', JSON.stringify(res.data.user))
     
      if (res.data.user) {
        if (res.data.user.role_name == 'admin') {
          this.dispatch('setRol', 1)
        } else {
          if (res.data.user.role_name == 'avanzado') this.dispatch('setRol', 2)
          else this.dispatch('setRol', 3)
        }
      }
    }
    catch (error) {
      return error;
    }
  },
  logout({ state }) {
    state.user = {}
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    console.log("logged out");
    router.push({path:'\login'})

  },
  setUser({state}, user){
    state.user = user
    localStorage.setItem('user', user)
  },
  setToken({state},token){
    localStorage.setItem('token', token)
  },


  /////////////// USUARIOS ///////////////
  getUsers({state}){
    return state.myAxios.get('users/')
  },
  getUser({state},user_id){
    return state.myAxios.get(`users/${user_id}`)
  },
  postUser({state},user){
    return state.myAxios.post('users/',user)
  },
  inactivateUser({state},user_id){
    return state.myAxios.put(`users/${user_id}`)
  },
  updateUser({state},user){
    return state.myAxios.put(`users/${user.id}`,user)
  },
 
  /////////////// EMAILS ////////////////////
  postEmail({state}, payload){
      return state.myAxios.post('emails/', payload)
  },
  updateEmail({state}, payload){
      return state.myAxios.put(`emails/${payload.id}`, payload)
  },
  deleteEmail({state}, id){
      return state.myAxios.delete(`emails/${id}`)
  },
  getEmails({state}){
      return state.myAxios.get('emails/')
  },





  /////////////// TIPOS DE TRATAMIENTO ////////////
  getTiposTratamiento({state}){
    return state.myAxios.get('tipos_tratamiento/')
  },
  postTipoTratamiento({state},payload){
    return state.myAxios.post('tipos_tratamiento/',payload)
  },
  putTipoTratamiento({state},payload){
    let url = `tipos_tratamiento/${payload.id}`
    console.log("el payload del put",payload)
    return state.myAxios.put(url,payload)
  },
  deleteTipoTratamiento({state},payload){
    let url = `tipos_tratamiento/${payload.id}`
    console.log("el payload del delete",payload)
    return state.myAxios.delete(url,payload)
  },


  ////// recetas //////
  getRecetas({state}){
    return state.myAxios.get('recetas/')
  },
  postReceta({state},payload){
    console.log(payload)
    //Primero crear la receta y después agregar el detalle
    let prom1= state.myAxios.post('recetas/',payload).then((response)=>{
      payload['id']= response.data.id
    })

  },
  putReceta({state},payload){
    let url = `recetas/${payload.id_receta}`
    console.log("el payload del put",payload)
    return state.myAxios.put(url,payload)
  },
  deleteReceta({state},payload){
    return state.myAxios.delete(`recetas/${payload.id_receta}`)
  },




  ////////////// trabajos ////////////////////
  postTrabajo({state},payload){
    return state.myAxios.post('trabajos',payload)
  },
  getTrabajo({state},id){
    return state.myAxios.get('trabajos/'+id)
  },
  putTrabajo({state},payload){
    const url = `trabajos/${payload.id_trabajo}`
    return state.myAxios.put(url,payload)
  },
  getUltimoTratamiento({state}){
    return state.myAxios.get('trabajos/last/')
  },
  getHistoricosTrabajos({state},fechas){
    return state.myAxios.get(`trabajos/historico`, {params:  fechas})

  },



  ////////////// alarmas ////////////////////

  getAlarmas({state}){
    return state.myAxios.get('alarmas/')
  },
  getHistoricoAlarmas({state}, payload){
    return state.myAxios.get(`alarmas/historico`,{params: payload})

  },
  // getUltimoTratamiento({state}){
  //   return state.myAxios.get('trabajos/last/')
  // },
  // getHistoricosTrabajos({state},fechas){
  //   return state.myAxios.get(`trabajos/historico`, {params:  fechas})

  // }

  getOfs({state},id){
    return state.myAxios.get('trabajos/ofs/'+id)
  },
  updateOfs({state},payload){
    return state.myAxios.put('trabajos/ofs/'+payload.id, payload)
  },
  deleteOfs({state},id){
    return state.myAxios.delete('trabajos/ofs/'+id)
  },
  createOf({state},id){
    return state.myAxios.post('trabajos/ofs/'+id)
  },


  /////////////// AJUSTES ////////////////////
  getAjuste({state},clave){
    return state.myAxios.get(`ajustes/${clave}`)
  },
  updateAjuste({state},payload){
    return state.myAxios.put(`ajustes/${payload.clave}`,{valor:payload.valor})
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}